export const SLIPPAGE_TOLERANCE = 7;
export const TRANSACTION_DEADLINE = 30;
export const UPDATE_INTERVAL = 40000;
export const FARM_BLOCKS_PER_YEAR = 10000000;

export const NATIVE_TOKEN_SYMBOL = 'BLUES';

export const DEPOSIT_PRICE_IMPACT_WARNING_PERCENT_FORM = 5;
export const WITHDRAW_PRICE_IMPACT_WARNING_PERCENT_FORM = 5;
